import React from 'react';

import Link from 'next/link';

import FooterCollapsible from '@components/common/Collapsible/FooterCollapsible/FooterCollapsible';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import useWindowSize from '@components/common/hooks/useWindowSize';
import Text from '@components/common/Text/Text';
import { M_DEVICE } from '@components/lpc/Constants';
import { potCreationTypeEnum } from '@models/PotModel/createPotCategoryModel';
import { getRoute, ROUTE } from '@services/http/Route';

import css from './Categories.module.scss';

const Categories = () => {
    const { t } = useTranslateLpc('lpc-footer');

    const categories = [
        [
            {
                title: t('categories.col-1.title'),
                rows: [
                    {
                        openInNewTab: false,
                        row: t('categories.col-1.row-1'),
                        link: ROUTE.LPC.HELP_CENTER.DETAILS,
                    },
                    {
                        openInNewTab: true,
                        row: t('categories.col-1.row-2'),
                        link: ROUTE.PRESS_AREA,
                    },
                    {
                        openInNewTab: false,
                        row: t('categories.col-1.row-3'),
                        link: ROUTE.LPC.ACTIVITY_REPORT,
                    },
                    {
                        openInNewTab: false,
                        row: t('categories.col-1.row-4'),
                        link: ROUTE.LPC.TEAM,
                    },
                ],
            },
            {
                title: t('categories.col-2.title'),
                rows: [
                    {
                        openInNewTab: true,
                        row: t('categories.col-2.row-1'),
                        link: { pathname: ROUTE.LPC.POT.CREATE_POT, query: { category: potCreationTypeEnum.LPC } },
                    },
                    {
                        openInNewTab: true,
                        row: t('categories.col-2.row-2'),
                        link: { pathname: ROUTE.LPC.POT.CREATE_POT, query: { category: potCreationTypeEnum.LPS } },
                    },
                ],
            },
        ],
        [
            {
                title: t('categories.col-3.title'),
                rows: [
                    {
                        openInNewTab: false,
                        row: t('categories.col-3.row-1'),
                        link: ROUTE.LPC.COOKIE,
                    },
                    {
                        openInNewTab: false,
                        row: t('categories.col-3.row-2'),
                        link: ROUTE.LPC.PRIVACY_POLITY,
                    },
                    {
                        openInNewTab: false,
                        row: t('categories.col-3.row-3'),
                        link: ROUTE.LPC.CGU,
                    },
                    {
                        openInNewTab: false,
                        row: t('categories.col-3.row-4'),
                        link: ROUTE.LPC.LEGAL_NOTICE,
                    },
                    {
                        openInNewTab: true,
                        row: t('categories.col-3.row-5'),
                        link: ROUTE.LPC.DONATION_CONTRACT,
                    },
                ],
            },
        ],
        [
            {
                title: '',
                rows: [
                    {
                        openInNewTab: true,
                        row: t('categories.col-3.row-6'),
                        link: ROUTE.LPC.CGU_XPOLLENS,
                    },
                    {
                        openInNewTab: false,
                        row: t('categories.col-3.row-7'),
                        link: 'https://www.xpollens.com/protection-donnees',
                    },
                    {
                        openInNewTab: false,
                        row: t('categories.col-3.row-8'),
                        link: ROUTE.LPC.MANGO_PAY_CGU,
                    },
                    {
                        openInNewTab: false,
                        row: t('categories.col-3.row-9'),
                        link: ROUTE.LPC.SECURITY,
                    },
                ],
            },
        ],
    ];
    const categoriesMobile = [
        {
            title: t('categories.col-1.title'),
            rows: [
                {
                    openInNewTab: false,
                    row: t('categories.col-1.row-1'),
                    link: ROUTE.LPC.HELP_CENTER.DETAILS,
                },
                {
                    openInNewTab: true,
                    row: t('categories.col-1.row-2'),
                    link: ROUTE.PRESS_AREA,
                },
                {
                    openInNewTab: false,
                    row: t('categories.col-1.row-3'),
                    link: ROUTE.LPC.ACTIVITY_REPORT,
                },
                {
                    openInNewTab: false,
                    row: t('categories.col-1.row-4'),
                    link: ROUTE.LPC.TEAM,
                },
            ],
        },
        {
            title: t('categories.col-2.title'),
            rows: [
                {
                    openInNewTab: true,
                    row: t('categories.col-2.row-1'),
                    link: { pathname: ROUTE.LPC.POT.CREATE_POT, query: { category: potCreationTypeEnum.LPC } },
                },
                {
                    openInNewTab: true,
                    row: t('categories.col-2.row-2'),
                    link: { pathname: ROUTE.LPC.POT.CREATE_POT, query: { category: potCreationTypeEnum.LPS } },
                },
            ],
        },
        {
            title: t('categories.col-3.title'),
            rows: [
                {
                    openInNewTab: false,
                    row: t('categories.col-3.row-1'),
                    link: ROUTE.LPC.COOKIE,
                },
                {
                    openInNewTab: false,
                    row: t('categories.col-3.row-2'),
                    link: ROUTE.LPC.PRIVACY_POLITY,
                },
                {
                    openInNewTab: false,
                    row: t('categories.col-3.row-3'),
                    link: ROUTE.LPC.CGU,
                },
                {
                    openInNewTab: false,
                    row: t('categories.col-3.row-4'),
                    link: ROUTE.LPC.LEGAL_NOTICE,
                },
                {
                    openInNewTab: true,
                    row: t('categories.col-3.row-5'),
                    link: ROUTE.LPC.DONATION_CONTRACT,
                },
                {
                    openInNewTab: true,
                    row: t('categories.col-3.row-6'),
                    link: ROUTE.LPC.CGU_XPOLLENS,
                },
                {
                    openInNewTab: false,
                    row: t('categories.col-3.row-7'),
                    link: 'https://www.xpollens.com/protection-donnees',
                },
                {
                    openInNewTab: false,
                    row: t('categories.col-3.row-8'),
                    link: ROUTE.LPC.MANGO_PAY_CGU,
                },
                {
                    openInNewTab: false,
                    row: t('categories.col-3.row-9'),
                    link: ROUTE.LPC.SECURITY,
                },
            ],
        },
    ];
    const { width } = useWindowSize();

    return (
        <div className={css.container}>
            <div className={css.container__col}>
                <div className={css.container__col__lpc}>
                    <Link href={getRoute(ROUTE.LPC.HOME)}>
                        <img src="/front-static/icons/logo/lpc.svg" alt={'Le pot commun'} />
                    </Link>
                    <Text variant={'body_03'} color={'black-gray'} customClass={css.container__col__lpc__title}>
                        {t('categories.title')}
                    </Text>
                    <Text
                        variant={'caption_02'}
                        color={'light-black-gray-tint-1'}
                        customClass={css.container__col__lpc__desc}
                    >
                        {t('categories.desc-1')}
                    </Text>
                </div>
                <div className={css.container__col__ifp}>
                    <img
                        src="/front-static/icons/logo/ifp.png"
                        alt={'Le pot commun'}
                        className={css.container__col__ifp__logo}
                    />
                    <Text
                        variant={'caption_02'}
                        color={'light-black-gray-tint-1'}
                        customClass={css.container__col__ifp__desc}
                    >
                        {t('categories.desc-2')}
                    </Text>
                </div>
            </div>
            {width > M_DEVICE
                ? categories.map((col, index) => (
                      <div key={index} className={css.container__col}>
                          {col.map((category, index) => (
                              <div key={index} className={css.container__col__content}>
                                  <Text
                                      customClass={css.container__col__content__title}
                                      variant={'label'}
                                      color={'black-gray'}
                                  >
                                      {category.title}
                                  </Text>
                                  <div className={css.container__col__content__links}>
                                      {category.rows.map((row, index) => (
                                          <Link key={index} href={row.link} target={row.openInNewTab ? '_blank' : ''}>
                                              <Text variant={'body_02'} color={'light-black-gray-tint-1'}>
                                                  {row.row}
                                              </Text>
                                          </Link>
                                      ))}
                                  </div>
                              </div>
                          ))}
                      </div>
                  ))
                : categoriesMobile.map((category) => (
                      <FooterCollapsible
                          elementId={category.title}
                          key={category.title}
                          trigger={category.title}
                          content={category.rows.map((row) => row)}
                      />
                  ))}
        </div>
    );
};

export default Categories;
